import React from "react";
import { ProtectedPageWrapper } from "../../designSystem/layouts/pageWrappers/ProtectedPageWrapper";
import { SingleColumnLayout } from "../../designSystem/layouts/SingleColumnLayout";
import { PageHeader } from "../../designSystem/PageHeader";
import { P } from "../../designSystem/typography/Body";


export default function ContactSupportPage(): JSX.Element 
{
    return (
        <ProtectedPageWrapper requiredPermissions={['ViewActivityOverview']}>
        
            <SingleColumnLayout
                noDivider
                contentContainer={
                    <>
                        <PageHeader headerText="Har du brug for hjælp?" headerStyle='primary-black' />
                        <P>
                        Hvis du har spørgsmål eller brug for assistance, er vi her for at hjælpe. <br/>
                        Send os en e-mail på <a href="mailto:support@amorg.dk">support@amorg.dk</a>, og vi vender tilbage så hurtigt som muligt.
                        </P>

                        <P>
                        Amorg er et produkt, der gør det nemt at
                        </P>
                        <ul>
                            <li>Oprette spørgeskemaer til afholdelse af APV</li>
                            <li>Se statestikker for besvarede spørgsmål udfra valgte parametre</li>
                            <li>Tilknytte handleplaner når spørgeskemaer er besvaret</li>
                            <li>Følge med i alle punkter i handleplan</li>
                            {/* <li>Planlægge og udføre sikkerhedsrunderinger</li> */}
                            <li>Arrangere AMOmøder</li>
                            <li>Oprette agendaer til AMOmøder</li>
                            <li>Skrive referat til AMOmøder</li>
                            {/* <li>Benytte vores whistleblowerordning</li> */}
                        </ul>
                        <P>
                            Vi er dedikerede til at sikre, at du får den bedst mulige oplevelse med vores løsning.<br /><br />
                            Hvis der er yderligere spørgsmål, er du velkommen til at kontakte os.<br />
                            Tak fordi du valgte os!
                        </P>
                    </>
                }
            />
        </ProtectedPageWrapper>

    );
}